module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[],"excludePattern":"(excluded-link|external)"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Search World Marketplace - Global Facebook Marketplace Search","short_name":"SearchWorld","description":"Search all Facebook Marketplace listings worldwide. Find items beyond the 100-mile radius.","start_url":"/","background_color":"#ffffff","theme_color":"#3b5998","display":"standalone","icon":"src/icons/icon.png","lang":"en","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0fb82b9046591018c59e16a5e7390709"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
